'use client'

import { GoogleAnalytics } from '@next/third-parties/google'
import { useMemo } from 'react'

const DEV_APP_HOST = 'app-dev.pubgen.ai'
const PROD_APP_HOST = 'app.pubgen.ai'

// Replace these with your real GA Measurement IDs.
const DEV_GA_MEASUREMENT_ID = ''
const PROD_GA_MEASUREMENT_ID = 'G-B38XH5DQ82'

function getGaMeasurementIdForHost(hostname: string) {
  if (hostname === DEV_APP_HOST || hostname.endsWith(`.${DEV_APP_HOST}`)) {
    return DEV_GA_MEASUREMENT_ID || null
  }

  if (hostname === PROD_APP_HOST || hostname.endsWith(`.${PROD_APP_HOST}`)) {
    return PROD_GA_MEASUREMENT_ID || null
  }

  return null
}

export function ProdGoogleAnalytics() {
  const gaId = useMemo(() => {
    if (typeof window === 'undefined') {
      return null
    }

    return getGaMeasurementIdForHost(window.location.hostname)
  }, [])

  if (!gaId) {
    return null
  }

  return <GoogleAnalytics gaId={gaId} />
}
